/**
 * @fileoverview Atom: busy indicator used by Suspense fallbacks and buttons.
 * @module components/atoms/Spinner
 */

import "./Spinner.css"

/** Props accepted by {@link Spinner}. */
export interface SpinnerProps {
	/** Physical size. Defaults to `md`. */
	readonly size?: "sm" | "md" | "lg"
	/** Message announced to assistive technology. */
	readonly label?: string
}

/**
 * Busy indicator.
 *
 * @param props - Size and accessible label.
 * @returns The rendered indicator, exposed as a live status region.
 */
export function Spinner({ size = "md", label = "Chargement…" }: SpinnerProps) {
	return (
		<span role="status" aria-live="polite">
			<span className={`spinner spinner--${size}`} aria-hidden="true" />
			<span className="visually-hidden">{label}</span>
		</span>
	)
}
